import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyPlansFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';

export interface PlansFileParameters {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const PlansFile: React.FC<PlansFileParameters> = ({ required, propertyGuid, isReview = false }) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyPlansFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Plans'
                    selector='plans'
                    fileType={'plans'}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
